const add32 = (a, b) => (a + b) | 0;
export default add32;
